import {createAction} from '@reduxjs/toolkit';

export const userNavigation = createAction<string>('USER_NAVIGATION');
